<template lang="pug">
SlideInPanel(:isOpen="sidePanelIsOpen" @close="$emit('close')" v-if="payment")
  .p-40
    .flex.justify-between.mb-S
      h3(class="w-3/4") {{ `Payment (${amount})` }}
      div.flex.justify-end
        BriqButton.mr-XXS(small variant="dark" @click="$emit('close')") Close
        BriqButton(small :disabled="!allowPaymentRefund" @click="$emit('refund', payment)")
          // todo: prevent absolute position from going outside window
          // briq-tooltip(v-if="disableRefundReason" :help="disableRefundReason")
          | Refund
    div
      BriqTable.dense
        tbody
          tr
            td.bold Key
            td {{ payment.Key }}
          tr
            td.bold Date
            td {{ formatDateTime(payment.CreateDatetimeUTC) }}
          tr
            td.bold Costs
            td {{ formattedAmount }}
          tr
            td.bold Method
            td {{ payment.PaymentMethod }}
          tr
            td.bold Status
            td {{ status }}
          tr
            td.bold Description
            td {{ payment.Description }}
          tr
            td.bold Processor
            td {{ payment.Processor }}
          tr
            td.bold PSP Reference
            td(v-if="hasPspLink" data-test-id="payment-psplink")
              a(:href="payment.PspLink" target="_blank") {{payment.PSPUniqueReference}}
            td(v-else) {{ payment.PSPUniqueReference }}
          tr
            td.bold Creating User
            td {{ payment.CreatingUser.Firstname}} {{ payment.CreatingUser.Lastname }} ({{ payment.CreatingUser.QualifiedUsername }})
          tr(v-if="payment.VoucherCode")
            td.bold Voucher code
            td {{ payment.VoucherCode }}
</template>

<script>
import { mapGetters } from 'vuex'
import SlideInPanel from '@v/components-global/layout/SlideInPanel.vue'
import SlideInBaseTemplate from '@v/components-global/layout/SlideInBaseTemplate.vue'
import { fromUtc } from '@/helpers/dateTimeFormatter.js'
import { currencyFormatter } from '@/helpers/intlFormatter.js'
import UserPermissionEnum from '@/vue/models/UserPermissionEnum'

export default {
  name: 'PaymentSlideInPanel',
  components: { SlideInPanel, SlideInBaseTemplate },
  props: {
    payment: Object,
    sidePanelIsOpen: Boolean,
    allowEdit: Boolean,
    amountPaid: Number,
  },
  computed: {
    ...mapGetters('briqState', ['businessUnitHasFeature', 'userHasPermission']),
    amount() {
      return this.$formatCurrency(this.payment?.Amount)
    },
    status() {
      return `${this.payment.Status} (${this.formatDateTime(this.payment.StatusDatetimeUTC)})`
    },
    formattedAmount() {
      return currencyFormatter(this.$locale, this.$currency).format(this.payment.Amount)
    },
    allowPaymentRefund() {
      const { IsRefundable, Amount, RefundableAmount } = this.payment
      const hasPermission = this.userHasPermission(UserPermissionEnum.API_Admin_Payment_Refund)
      return hasPermission && IsRefundable && RefundableAmount > 0
    },
    hasPspLink() {
      return this.payment.PspLink !== null
    },
    disableRefundReason() {
      const { IsRefundable, Amount, RefundableAmount } = this.payment
      const hasPermission = this.userHasPermission(UserPermissionEnum.API_Admin_Payment_Refund)
      if (!hasPermission) return 'You do not have permission to refund payments'
      if (!IsRefundable) return 'This payment is not refundable'
      if (RefundableAmount !== Amount)
        return 'The refundable amount does not equal the amount of the payment'
      return null
    },
  },
  methods: {
    formatDateTime(dateTimeUtc) {
      return fromUtc()(this.$locale)(this.$timezone)(dateTimeUtc)
    },
  },
}
</script>

<style scoped lang="stylus">
.w-70percent
  width 70%

a
  text-decoration underline

.title-amount
    font-weight normal
</style>
